import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  exibeMensagemErro,
  limpaMensagem,
  mostraAguardando,
  escondeAguardando,
} from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import api from "../../services/api";
import { PainelDisponibilidadeGrid } from "./PainelDisponibilidadeGrid";
import { ButtonBack } from "../Button/Back";
import "./PainelDisponibilidade.css";

const mapDispatchToProps = {
  exibeMensagemErro,
  limpaMensagem,
  mostraAguardando,
  escondeAguardando,
};

const mapStateToProps = (state) => ({
  user: state.usuarioStore.user,
});

export const PainelDisponibilidade = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    class extends Component {
      constructor(props) {
        super(props);
        this.state = {
          situacoes: [],
        };

        this.carregarSituacoes = this.carregarSituacoes.bind(this);
      }

      componentDidMount() {
        this.props.limpaMensagem();
        this.carregarSituacoes();
      }

      carregarSituacoes() {
        this.props.mostraAguardando();

        api
          .get("/api/painel-disponibilidade")
          .then((response) => {
            this.setState({ situacoes: response.data || [] });
          })
          .catch((erro) => {
            const mensagemErro = erro && erro.data && erro.data.erro ? erro.data.erro : "Erro durante o carregamento do Health Check APIs.";
            this.props.exibeMensagemErro(mensagemErro);
          })
          .finally(() => {
            this.props.escondeAguardando();
          });
      }

      render() {
        const { situacoes } = this.state;

        return (
          <main id="content" className="page-content p-3">
            <Message />
            <Loading />

            <section className="painel-disponibilidade-header">
              <h1>Servicos e API Monitorados</h1>
              <div className="painel-disponibilidade-legenda">
                <span>
                  <i className="fas fa-circle painel-disponibilidade-legenda__disponivel" aria-hidden="true"></i>
                  Disponivel
                </span>
                <span>
                  <i className="fas fa-circle painel-disponibilidade-legenda__indisponivel" aria-hidden="true"></i>
                  Indisponivel
                </span>
                <span>
                  <i className="fas fa-circle painel-disponibilidade-legenda__sem-dados" aria-hidden="true"></i>
                  Sem dados recentes
                </span>
              </div>
            </section>

            <div className="div-form">
              <div className="container-fluid">
                <div className="br-form">

                  {situacoes.length > 0 && <PainelDisponibilidadeGrid situacoes={situacoes} />}

                  {situacoes.length === 0 && (
                    <div className="painel-disponibilidade-vazio">Nenhuma API monitorada com acesso para o usuario logado.</div>
                  )}

                  <div className="actions-button">
                    <div className="actions justify-content-start">
                      <ButtonBack />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </main>
        );
      }
    }
  )
);
